/** @format */

import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import withStyles from '@material-ui/core/styles/withStyles';
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import simcardStyle from 'assets/jss/adescom/adescomStyle';
import TariffsRange from 'components/Adescom/SimpleSelectRest';
import ActionButton from 'components/Buttons/CustomTextButton';
import { FormGeneralHelper } from 'helpers/FormGeneral';
import DatePickerForm from 'components/Form/DatePickerForm';
import { operationOnSimcardActions, operationOnSimcardConstants } from '../../../modules/simcard/operationOnSimcard';
import { iccidType } from '../../../helpers/iccidStatus';
import { AlertDialog } from '../../lib/dialog/AlertDialog';
import { ItemLoaders } from '../../../core/loaders/ItemLoaders';
import { SimpleSelect } from '../../../components/Adescom/SimpleSelect';
import moment from 'moment';
import { ReleasingESimCard } from '../../Storage/imsi/ReleasingESimCard';

class IccidActivate extends PureComponent {
    constructor(props, context) {
        super(props, context);

        this.state = {
            iccid: this.props.iccid,
            autoactivationdate: null,
            simCard: this.props.simCard,
            showActiveButton: true,
            showCancelButton: true,
            activationMnpParams: null,
            alertOpen: false,
            alertTitleDialog: null,
            alertDisplayMessage: null,
            alertConfirmCallback: () => {},
            mvnoOperatorSetup: null,
            tariffPlanId: null,
            virtualComponentTemplates: null,
            virtualComponentTemplateId: null,
            portInDate: null,
        };
    }

    componentDidMount() {
        const { simCard } = this.props;
        this.loadMnoOperatorSetup();
        this.loadSimCardServiceTemplate();
        if (simCard.isPorted) {
            this.loadMsisdn();
        }
    }

    loadMsisdn = () => {
        const { dispatch, simCard } = this.props;
        const itemLoader = new ItemLoaders(dispatch);
        itemLoader.getWithCallback(
            FormGeneralHelper.getByUri(simCard.platformMsisdnPoolNumber),
            'no-dispatch',
            (data) => {
                const current = moment();
                let date = moment(data.portinDate).set({ hour: 2, minute: 0, second: 0 });
                if (date.isBefore(current)) {
                    date = current;
                }
                this.setState({
                    portInDate: date,
                    autoactivationdate: date.format('YYYY-MM-DD HH:mm:ss'),
                });
            },
            {
                propagateDataToCallback: true,
                dispatchAfterCallback: false,
            }
        );
    };

    loadSimCardServiceTemplate = () => {
        const { dispatch } = this.props;
        const { virtualComponentTemplates, iccid } = this.state;
        if (!virtualComponentTemplates) {
            const itemLoader = new ItemLoaders(dispatch);
            itemLoader.getListWithCallback(
                FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/sim_card_service_templates')),
                'sim_card_services_types_list_load_activate_sim_card',
                [
                    { name: 'platformResellerId', value: iccid.ownerPlatformResellerId },
                    { name: 'systemRestrictedFlag', value: false },
                    { name: 'clip', value: true },
                    { name: 'ussdSmsCommunicationId', value: -1 },
                    { name: 'active', value: true },
                ],
                [{ name: 'description', value: 'asc' }],
                (data) => {
                    const header = [];
                    for (let i = 0; i < data['hydra:member'].length; i++) {
                        header.push({ name: data['hydra:member'][i].templateName, value: data['hydra:member'][i].id });
                    }
                    this.setState({
                        virtualComponentTemplates: header,
                    });
                },
                { propagateDataToCallback: true, dispatchAfterCallback: false }
            );
        }
    };

    loadMnoOperatorSetup = () => {
        const { iccid } = this.state;
        const { dispatch } = this.props;
        if (iccid) {
            const itemLoader = new ItemLoaders(dispatch);
            itemLoader.getListWithCallback(
                FormGeneralHelper.getUrl('/mvno_operator_setups'),
                'get_mvno_opertor_setup_list_iccid_parring',
                [
                    { name: 'operatorType', value: iccid.operatorType },
                    { name: 'typeValue', value: 'TARIFF' },
                    { name: 'platformResellerId', value: iccid.ownerPlatformResellerId },
                ],
                [{ name: 'diplayName', value: 'asc' }],
                (response) => {
                    let data = [];
                    let tariffPlanId = null;
                    for (let i = 0; i < response['hydra:member'].length; i++) {
                        data.push({
                            name: response['hydra:member'][i].displayName,
                            id: response['hydra:member'][i].constName,
                            prepaid: response['hydra:member'][i].prepaid,
                        });
                        if (response['hydra:member'][i].constValue === iccid.defaultTariff) {
                            tariffPlanId = response['hydra:member'][i].constName;
                        }
                    }
                    this.setState({
                        mvnoOperatorSetup: { 'hydra:member': data },
                        tariffPlanId: tariffPlanId,
                    });
                },
                { dispatchAfterCallback: false, propagateDataToCallback: true }
            );
        }
    };

    confirmAction = (messageTitle, messageBody, callback) => {
        this.setState({
            alertOpen: true,
            alertTitleDialog: messageTitle,
            alertDisplayMessage: messageBody,
            alertConfirmCallback: callback,
        });
    };

    saveAndActivateSimCard = () => {
        this.setState({ showActiveButton: false, showCancelButton: false }, () => {
            const { dispatch } = this.props;
            const { simCard, tariffPlanId, autoactivationdate, virtualComponentTemplateId } = this.state;
            const params = {
                id: simCard.id,
                activate: true,
                activateAtDate: autoactivationdate,
                activateWithTariff: tariffPlanId,
                virtualComponentTemplateId: virtualComponentTemplateId,
            };
            const itemLoader = new ItemLoaders(dispatch);
            itemLoader.putWithCallback(
                FormGeneralHelper.getUrl('/operation_on_sim_cards/' + simCard.id),
                operationOnSimcardConstants.SIM_CARD_ACTIVATE_PUT,
                params,
                {
                    onSuccess: (data) => {
                        this.props.refreshPage();
                    },
                    onError: () => {
                        this.setState({
                            showActiveButton: true,
                            showCancelButton: true,
                        });
                    },
                },
                { propagateDataToCallback: true, dispatchErrorAfterCallback: true }
            );
        });
    };

    cancelActivationRequest = (simCard) => {
        this.setState({ showActionButton: false, showCancelButton: false }, () => {
            const { dispatch } = this.props;
            const { simCard } = this.state;
            const params = {
                id: simCard.id,
                activationCancel: true,
            };
            dispatch(
                operationOnSimcardActions.put(
                    FormGeneralHelper.getUrl('/operation_on_sim_cards/' + simCard.id),
                    params,
                    operationOnSimcardConstants.SIM_CARD_CANCEL_ACTIVATION,
                    (data) => {
                        this.props.refreshPage();
                    },
                    { propagateDataToCallback: true }
                )
            );
        });
    };

    setPlatformResellerCallback = (event) => this.setState({ virtualComponentTemplateId: parseInt(event.target.value) });

    dateTimeCallback = (moment) => {
        let dateTime = null;
        if (moment) {
            dateTime = moment.format('YYYY-MM-DD HH:mm:ss');
        }
        this.setState({
            autoactivationdate: dateTime,
        });
    };

    render() {
        const {
            tariffPlanId,
            showActiveButton,
            showCancelButton,
            simCard,
            iccid,
            alertOpen,
            alertTitleDialog,
            alertDisplayMessage,
            alertConfirmCallback,
            mvnoOperatorSetup,
            virtualComponentTemplates,
            virtualComponentTemplateId,
            portInDate,
        } = this.state;
        const { refreshPage } = this.props;

        return (
            <GridContainer>
                <GridItem xs={6}>
                    {mvnoOperatorSetup && (
                        <TariffsRange
                            callback={this.selectFunc}
                            restElements={mvnoOperatorSetup}
                            stateName="tariffPlanId"
                            idState="tariffPlanId"
                            idSelected={tariffPlanId}
                            propKey="id"
                            required={false}
                            propValue="name"
                            emptyLabel="general:common.empty_label"
                            label="pools:sim.service_profile"
                        />
                    )}
                </GridItem>
                <GridItem xs={6}>
                    {(simCard.isPorted === false || (simCard.isPorted && portInDate)) && (
                        <DatePickerForm helpText="simcard:add.activation_date" callback={this.dateTimeCallback} defaultValue={portInDate} />
                    )}
                </GridItem>
                <GridItem xs={6}>
                    {virtualComponentTemplates && virtualComponentTemplates.length > 0 && (
                        <SimpleSelect
                            label="prov:features.activate_with_group"
                            required={simCard && !simCard.allowChangeExpiryDateOnComponent}
                            elements={virtualComponentTemplates}
                            fieldName="virtualComponentId"
                            dispatchName={'none'}
                            selectedValue={virtualComponentTemplateId}
                            callback={this.setPlatformResellerCallback}
                        />
                    )}
                </GridItem>
                <GridItem xs={12}>
                    {iccid.eSimPreActivateAllowed && !simCard.preActivateState && (
                        <ReleasingESimCard
                            iccid={iccid}
                            simCard={simCard}
                            reloadPage={refreshPage}
                            tariffPlanId={tariffPlanId}
                            virtualComponentTemplateId={virtualComponentTemplateId}
                        />
                    )}
                    {showActiveButton && (
                        <ActionButton
                            callback={() => {
                                this.confirmAction(
                                    'simcard:add.confirm_activate_sim_card',
                                    iccid.iccidType !== iccidType.ESIM
                                        ? 'simcard:add.confirm_activate_sim_card_description'
                                        : 'simcard:add.confirm_activate_esim_sim_card_description',
                                    this.saveAndActivateSimCard
                                );
                            }}
                            callbackParam={{}}
                            label="simcard:add.activate_sim_card"
                            size="sm"
                        />
                    )}
                    {showCancelButton && iccid.iccidType !== iccidType.E && (
                        <ActionButton
                            callback={() => {
                                this.confirmAction(
                                    'simcard:add.confirm_cancel_activate_sim_card',
                                    'simcard:add.confirm_cancel_activate_sim_card_description',
                                    () => {
                                        this.cancelActivationRequest(simCard);
                                    }
                                );
                            }}
                            callbackParam={{}}
                            label="simcard:add.break_activation_request"
                            size="sm"
                        />
                    )}
                    <AlertDialog
                        open={alertOpen}
                        titleDialog={alertTitleDialog}
                        displayMessage={alertDisplayMessage}
                        closeCallback={() => {
                            this.setState({ alertOpen: false });
                        }}
                        confirmCallback={alertConfirmCallback}
                    />
                </GridItem>
            </GridContainer>
        );
    }
}

IccidActivate.propTypes = {
    classes: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => {
    return {
        ...state,
    };
};
const enhance = compose(connect(mapStateToProps), withStyles(simcardStyle));
const Enhance = enhance(IccidActivate);
export default Enhance;
